import { combineReducers } from 'redux';
import ArrayUtil from '@leverege/array-util'

import { Constants } from '~/actions/'

const initialState = {
  status : 'none',
  statusMessage : null, 
  systemId : null,
  system : null,
  total : 0,
  perPage : 100,
  items : [],
  lookup : {},
  loading : false
};

function devices( state = initialState, action ) {
 
  // TODO: These copies are too much. only create new list/object.
  // and replce elements
  switch ( action.type ) {

    case Constants.GET_DEVICES_STATUS: {
      const nState = { ...state }
      nState.status = action.status
      nState.statusMessage = action.statusMessage
      return nState
    }

    case 'GET_DEVICE': {
      const { device } = action
      const nState = {
        ...state,
        lookup : {
          ...state.lookup,
          [device.id] : device
        }
      }
      return nState
    }

    case Constants.GET_DEVICES: {

      const nState = {
        system : action.system,
        systemId : action.systemId,
        status : null,
        total : action.total,
        perPage : action.perPage,
        status : Constants.STATUS_DONE,
        statusMessage : null,
        search : action.search
      }

      if ( action.systemId != state.systemId || action.search != state.search ) {
        nState.items = new Array( action.total )
      } else {
        nState.items = [].concat( state.items )
      }

      // copy new devices into the array
      for ( let n = 0, tn = action.startIndex; n < action.items.length; n++, tn++ ) {
        nState.items[tn] = action.items[n]
      }
      return nState
    }

    case Constants.UPDATE_DEVICE: {
      const nState = { ...state }
      nState.items = [].concat( state.items || [] )
      nState.lookup = { ...nState.lookup }

      if ( action.device != null ) {
        ArrayUtil.replace( nState.items, 'id', action.device.id, action.device )
        nState.lookup[action.device.id] = action.device
      }
      return nState;
    }

    case Constants.ADD_DEVICE: {
      const nState = { ...state }
      nState.items = [].concat( state.items || [] )
      nState.items.push( action.device )
      return nState;
    }

    case Constants.REMOVE_DEVICE: {
      const nState = { ...state }
      nState.items = [].concat( state.items || [] )
      ArrayUtil.remove( nState.items, 'id', action.device.id )
      return nState;
    }

    default:
      return state
  }
}

module.exports = devices;
